import React, { useState, useEffect } from "react";
import { Modal, Button, Nav, NavItem, NavLink } from 'react-bootstrap';
import { Checkbox, Input, Select, TextArea } from '../../../Layout/Forms/Form'
import './Campaign.css';
import CampaignsRequests from "../CampaignsRequests";

const ModalCampaignAction = ({ show, handleModalhide, form, handleChangeForm, handlerSubmitCampain, handleSetErrors }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState({
        events: [],
        venues: []
    })

    const getInfoVenuesEvents = async () => {
        let info = await CampaignsRequests.getVenuesEventsPromote();
        if (info && info.status) {
            setState(info.data)
        }
    }

    useEffect(() => {
        if (show) {
            getInfoVenuesEvents()
        }
    }, [show])


    const seriaizeVenues = () => {
        return state.venues.map((item) => {
            return {
                label: item.name,
                value: item.id
            }
        })
    }


    const seriaizeEvents = () => {
        return state.events.map((item) => {
            return {
                label: item.name,
                value: item.id
            }
        })
    }


    const SelectEventsToPromote = () => {
        //if (form.message.target_type === "event") {
        return (
            <div className="col-6">
                <Select
                    label="Selecionar evento"
                    name="target_id"
                    value={form.message.target_id}
                    onChangeOption={(e) => handleChangeForm(e)}
                    options={seriaizeEvents()}
                    errors={form.errors}
                />
            </div>
        )
        //}
        return null;
    }

    const SelectVenuesToPromote = () => {
        if (form.message.target_type === "venue") {
            return (
                <div className="col-6">
                    <Select
                        label="Spots"
                        name="target_id"
                        value={form.message.target_id}
                        onChangeOption={(e) => handleChangeForm(e)}
                        options={seriaizeVenues()}
                        errors={form.errors}
                    />
                </div>
            )
        }
        return null;
    }

    const countGsm7TextSegments = (text) => {
        const GSM7_EXT_CHARS = "^{}[]~|€";
        const bitPackingRatio = 7 / 8;

        const countCodeUnits = (character) => {
            return GSM7_EXT_CHARS.includes(character) ? 2 : 1;
        };

        let msgLength = 0;
        for (let i = 0; i < text.length; i++) {
            msgLength += countCodeUnits(text[i]);
        }

        const byteLength = Math.ceil(msgLength * bitPackingRatio);

        if (byteLength <= 140) {
            return 1;
        }

        return Math.ceil(byteLength / 134);
    };

    const handlerCampainAction = () => {
        if (form.message.text.length <= 0) {
            handleSetErrors({ target: { name: "text", value: "A mensagem não pode estar vazia" } })
            return;
        }

        if (form.type == "sms") {
            const validateTextSegments = countGsm7TextSegments(form.message.text)
            console.log(validateTextSegments)
            if (validateTextSegments > 1) {
                handleSetErrors({ target: { name: "text", value: "O texto ultrapassa o tamanho máximo que uma mensagem pode conter." } })
                return;
            }
        }
        console.log("AQUIII #1" + form.message.target_type.length);
        if (form.message.target_type.length <= 0) {
            handleSetErrors({ target: { name: "target_type", value: "Selecione um objetivo" } })
            return;
        }

        if (form.message.target_id.length <= 0 || parseInt(form.message.target_id) <= 0) {
            let destino = "Destino";
            if (form.message.target_type == "venue") {
                destino = "Spot"
            } else if (form.message.target_type == "event") {
                destino = "Evento"
            }
            handleSetErrors({ target: { name: "target_id", value: "Selecione um " + destino } })
            return;
        }

        // if (form.limits.limit == 0) {
        //     handleSetErrors({ target: { name: "target_id", value: "Não têm contactos para enviar notificações." } })
        //     return;
        // }
        // if (form.limits.total == 0) {
        //     handleSetErrors({ target: { name: "target_id", value: "Não têm notificações disponiveis para usar. Faça upgrade ao seu plano." } })
        //     return;
        // }

        handlerSubmitCampain()
    }

    const insertVariable = (variable) => {
        const textarea = document.getElementsByName('text')[0];
        if (!textarea) return;

        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        const text = form.message.text;
        const before = text.substring(0, start);
        const after = text.substring(end);

        const newText = before + variable + after;

        handleChangeForm({
            target: {
                name: 'text',
                value: newText
            }
        });

        // Focus back on textarea after a short delay
        setTimeout(() => {
            textarea.focus();
            textarea.setSelectionRange(start + variable.length, start + variable.length);
        }, 10);
    };

    useEffect(() => {
        // Auto-fill template if text is empty and a target is selected
        if (show && form.message.text === "" && form.message.target_id > 0) {
            let template = "";
            const eventName = state.events.find(e => e.id == form.message.target_id)?.name || "este evento";

            if (form.type === 'sms') {
                template = `Olá {{nome_destinatario}}, não percas o ${eventName}! Reserva já em: {{url_evento}}`;
            } else if (form.type === 'whatsapp') {
                template = `Olá {{nome_destinatario}}! 👋\n\nSabemos que gostas do Nightspot, por isso queríamos avisar-te que o ${eventName} vai ser épico! 🔥\n\nVê todos os detalhes e garante o teu lugar aqui: {{url_evento}}`;
            } else {
                template = `Olá {{nome_destinatario}}, vê o que preparámos para ti no ${eventName}! 🚀`;
            }

            handleChangeForm({
                target: {
                    name: 'text',
                    value: template
                }
            });
        }
    }, [form.message.target_id, form.type, show]);

    const MobilePreview = () => {
        let previewText = form.message.text || "Escreve aqui o conteúdo da tua mensagem para veres como fica no telemóvel...";

        // Compile variables for preview
        previewText = previewText
            .replace(/{{nome_destinatario}}/g, "Ricardo")
            .replace(/{{url_evento}}/g, "nightspotapp.com/v/example");

        return (
            <div className="mobile-mockup-container">
                <div className="mobile-screen">
                    {/* App Notification Preview */}
                    {form.type === "notification" && (
                        <div className="preview-notification-wrapper">
                            <div className="notification-banner">
                                <div className="notification-header">
                                    <div className="notification-icon"></div>
                                    <span className="notification-app-name">NIGHTSPOT</span>
                                    <span className="notification-time">agora</span>
                                </div>
                                <div className="notification-title">✨ Novidades para ti</div>
                                <div className="notification-body">{previewText}</div>
                            </div>
                        </div>
                    )}

                    {/* SMS Preview */}
                    {form.type === "sms" && (
                        <div className="preview-sms-wrapper">
                            <div className="sms-header">Nightspot</div>
                            <div className="sms-bubble">
                                {previewText}
                            </div>
                        </div>
                    )}

                    {/* WhatsApp Preview */}
                    {form.type === "whatsapp" && (
                        <div className="preview-whatsapp-wrapper">
                            <div className="wa-header">
                                <div className="wa-avatar"></div>
                                <div className="wa-name">Nightspot Support</div>
                            </div>
                            <div className="wa-bubble">
                                {previewText}
                                <div className="wa-time">12:45</div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    };

    return (
        <>
            <Modal
                show={show}
                onHide={handleModalhide}
                size="xl"
                centered
                contentClassName="campaign-card border-0"
                style={{ backgroundColor: 'transparent' }}
            >
                <Modal.Header closeButton className="border-0 pb-0" style={{ background: '#0f172a', border: 'none' }}>
                    <Modal.Title className="campaigns-section-title fs-3 mb-0">✍️ Design da Campanha</Modal.Title>
                </Modal.Header>

                <Modal.Body className="py-4" style={{ background: '#0f172a', border: 'none' }}>
                    <div className="row">
                        {/* Editor Side */}
                        <div className="col-12 col-lg-7 border-end border-white border-opacity-10 pe-lg-4">
                            <div className="row g-3">
                                <div className="col-12 d-none">
                                    <Select
                                        label="Objetivo da campanha"
                                        name="target_type"
                                        value={form.message.target_type}
                                        onChangeOption={(e) => handleChangeForm(e)}
                                        options={[
                                            { label: 'Spot', value: 'venue' },
                                            { label: 'Evento', value: 'event' },
                                        ]}
                                        errors={form.errors}
                                    />
                                </div>
                                <SelectEventsToPromote />
                                <SelectVenuesToPromote />
                            </div>

                            <div className="row mt-4">
                                <div className="col-12">
                                    <TextArea
                                        label="Conteúdo da Mensagem"
                                        name="text"
                                        rows={6}
                                        value={form.message.text}
                                        onChange={(e) => handleChangeForm(e)}
                                        errors={form.errors}
                                        placeholder="O que queres dizer ao teu público?"
                                    />

                                    <div className="mt-2 d-flex flex-wrap gap-2">
                                        <span className="text-muted small w-100 mb-1">Inserir Variável:</span>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-outline-light border-opacity-10 rounded-pill px-3"
                                            onClick={() => insertVariable('{{nome_destinatario}}')}
                                            style={{ fontSize: '0.75rem', background: 'rgba(255,255,255,0.05)' }}
                                        >
                                            <i className="fa-solid fa-user me-2 text-nightspot"></i>
                                            Nome do Cliente
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-outline-light border-opacity-10 rounded-pill px-3"
                                            onClick={() => insertVariable('{{url_evento}}')}
                                            style={{ fontSize: '0.75rem', background: 'rgba(255,255,255,0.05)' }}
                                        >
                                            <i className="fa-solid fa-link me-2 text-nightspot"></i>
                                            URL do Evento
                                        </button>
                                    </div>
                                    <div className="mt-4 p-3 instruction-box rounded-4 border-nightspot border-opacity-10">
                                        <div className="d-flex align-items-center mb-2">
                                            <div className="bg-nightspot bg-opacity-10 p-2 rounded-circle me-3">
                                                <i className="fa-solid fa-wand-magic-sparkles text-nightspot"></i>
                                            </div>
                                            <span className="text-white small fw-bold text-uppercase ls-1">Dica de Marketing</span>
                                        </div>
                                        <p className="text-muted small mb-0 lh-base ps-1">
                                            {form.type === 'sms'
                                                ? "Sê direto nas SMS. Começa com uma oferta ou o nome do evento para captar atenção imediata."
                                                : form.type === 'whatsapp'
                                                    ? "No WhatsApp podes usar emojis e uma linguagem mais próxima. Lembra-te de incluir um CTA claro."
                                                    : "As notificações push devem ser curtas e urgentes. Usa palavras como 'Hoje', 'Agora' ou 'Última Chance'."}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Preview Side */}
                        <div className="col-12 col-lg-5 ps-lg-4 d-flex flex-column align-items-center justify-content-center mt-4 mt-lg-0">
                            <h6 className="text-white opacity-50 mb-3 text-uppercase small ls-1">Pré-visualização em Tempo Real</h6>
                            <MobilePreview />
                            <div className="mt-3 text-center">
                                <span className="badge rounded-pill bg-white bg-opacity-10 text-muted px-3 py-2">
                                    Canal: <span className="text-white text-capitalize">{form.type}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer className="border-0 pt-0" style={{ background: '#0f172a', border: 'none' }}>
                    <button
                        onClick={handleModalhide}
                        className="btn-action btn-campaign-secondary px-4 rounded-pill border-0 w-auto py-2 me-2"
                    >
                        <i className="fa-solid fa-arrow-left me-2"></i>
                        Anterior
                    </button>
                    <button
                        onClick={handlerCampainAction}
                        className="btn-action btn-campaign-primary px-4 rounded-pill border-0 w-auto py-2"
                    >
                        Seguinte
                        <i className="fa-solid fa-arrow-right ms-2"></i>
                    </button>
                </Modal.Footer>
            </Modal>



        </>
    )
}


export default ModalCampaignAction